import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupFlowService } from '@app/modules/signup-new/services/signup-flow.service';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { SignupWizardService } from '@app/modules/signup-new/services/signup-wizard.service';
import { SignUpErrorResponse, SignupStatusError } from '@app/shared/+state/users/users.models';
import { LocalStorageKey, QueryParams } from '@app/shared/interfaces';
import { catchError, EMPTY } from 'rxjs';

@Component({
  selector: 'sbnb-signup-with-airbnb-callback',
  templateUrl: './signup-with-airbnb-callback.component.html',
})
export class SignupWithAirbnbCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private signupUserService: SignupUserService,
    private signupWizardService: SignupWizardService,
    private signupFlowService: SignupFlowService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const error = params[QueryParams.AirbnbError];
      const code = params[QueryParams.AirbnbCode];
      const state = params[QueryParams.AirbnbState];

      if (code && state) {
        if (localStorage.getItem(LocalStorageKey.signUpAirbnbStateNew) !== state) {
          this.redirectToWelcome(SignupStatusError.InvalidState);
        } else {
          this.signupUserService
            .signUpWithAirbnbCallback(code, state, this.signupFlowService.flow$.value)
            .pipe(
              catchError((error: SignUpErrorResponse) => {
                this.redirectToWelcome(SignupStatusError.ApiError, this.getErrorMessage(error));
                return EMPTY;
              })
            )
            .subscribe((response) => {
              this.signupUserService.user$.next(response.user);
              this.signupWizardService.init();
            });
        }

        return;
      }

      this.redirectToWelcome(error === SignupStatusError.Denied ? SignupStatusError.Denied : SignupStatusError.Unknown);
    });
  }

  redirectToWelcome(error: SignupStatusError, message?: string) {
    this.router.navigate(['/signup'], {
      queryParams: {
        [QueryParams.AirbnbError]: error,
        [QueryParams.AirbnbErrorMessage]: message,
      },
    });
  }

  getErrorMessage(response: SignUpErrorResponse) {
    let error: string;

    if (response && response.error) {
      if (response.error.error_message) {
        error = response.error.error_message;
      }

      if (response.error.detail && typeof response.error.detail === 'string') {
        error = response.error.detail;
      }
    }

    return error;
  }
}
